module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "fm"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Chap-Title-ct"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_11",
      "title": "11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_fm",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Colonna-MT"
  }, [_vm._v("THE CRAFTPERSONS FILE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Subtitle-cst"
  }, [_vm._v("(WHAT HAS GONE BEFORE)")]), _vm._v(" "), _c('p', {
    staticClass: "CO1"
  }, [_vm._v("STOP! If you are not cleared for documents classified TOP SECRET EX-22, return this file to the office of Director J. Edgar Edwards "), _c('span', {
    staticClass: "ePub-U"
  }, [_vm._v("immediately")]), _vm._v(". Anyone reading further without such clearance is subject to instant sanction.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("TOP SECRET//EX-22/CRAFTPRO/FOUO/NOFORN/ORGCON")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("ORDERS")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("From: Eddy Edwards, Director, Special Surveillance Service, CIA")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext1"
  }, [_vm._v("To: Inductees; Morton/Endicott Farsight Analysis Team")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext1"
  }, [_vm._v("Re: "), _c('span', {
    staticClass: "ePub-U"
  }, [_vm._v("Background of Certain AWOL Practitioners and Their Associates; Order Regarding Same")])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("Some of you receiving this memorandum and order are currently being read into the craft secrets: the covert history and activities of magician-soldiers and psychic spies at home and abroad. You have waived your right to due process of law and your related constitutional rights in the event you disclose any of this material.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("How will we know if you’ve disclosed? If you’ve heard whispers about “The Peepshow,” that’s us. Our intelligence service is responsible for viewing events and persons in the future or at a distance. If you disclose anything, we will know it, perhaps in advance, and we will find you and kill you. My apologies, but absolute clarity on this point is more important than sugarcoating the message.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("What follows is the necessary background for understanding the recent activities of Major Dale Morton, Major Michael G. Endicott, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_12",
      "title": "12"
    }
  }, [_vm._v("and Lieutenant Scherezade Rezvani, all absent without leave and in the company of Royal Navy Commander Grace Marlow in Tokyo, Japan (collectively, the “AWOL practitioners”).")])]), _vm._v(" "), _c('p', {
    staticClass: "Head-Level-1-h1"
  }, [_vm._v("I. THE MORTON AND REZVANI FAMILIES")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("The Mortons are descendants of Thomas Morton of the Merry Mount settlement. Many of the Mortons are excellent weathermen (controllers of local weather). They often can see a person’s “sins” (either committed or intended) in the form of glowing letters. They also may have forebodings of their imminent deaths. The Mortons have a mutual-protection compact with the American Sanctuary, and Dale Morton was able to obtain temporary asylum there during his self-initiated mission to uncover the Left-Hand cabal in the Pentagon’s craft service section, “H-ring.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The orthodox branch of the Morton Family has saved the armed forces of the United States on several occasions. But the Left-Hand branch of the Mortons once led the craft world in the forbidden practices of life extension, psychic vampirism, and possession, with an accompaniment of mass murder.")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A. The Left-Hand Twins: Roderick and Madeline.")])]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-Paragraphs-np-First"
  }, [_vm._v("1. Madeline Ligeia Morton. Deceased. Madeline’s ghost is currently the leading voice in the Left-Hand Morton collective spiritual entity. During the later part of Madeline’s centuries-long life, she was one of the leaders of the Left-Hand cabal within H-ring. She practiced the art of life extension through possession of a series of young bodies; the last living body she fully possessed was of a Gideon special ops tracker, code name Sakakawea (Captain Shannon McRae).")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-Paragraphs-Subsequent-Para-nptx"
  }, [_vm._v("In death, Madeline has shown an unexpected protectiveness toward her living family, particularly toward Dale Morton’s spouse, Scherie Rezvani. We cannot determine the ultimate goal of this strategy. At"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_13",
      "title": "13"
    }
  }, [_vm._v("tempts to foresee Madeline’s actions induce headaches, nausea, and PTSD. She is at least as dangerous in death as she was in life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-Paragraphs-np"
  }, [_vm._v("2. Roderick Morton, aka “The Red Death.” Deceased, spirit presumed destroyed. In the early 1800s, he led the Left-Hand cause until the orthodox Mortons and the other craft Families defeated him. He survived as a decomposing head subject to the will of his twin sister Madeline and her lover Abram Endicott, and he only recently gained his freedom during that H-ring cabal’s downfall.")]), _vm._v(" "), _c('p', {
    staticClass: "Numbered-Paragraphs-Subsequent-Para-nptx"
  }, [_vm._v("With a new body and a new home in Kiev, Roderick attempted to suborn the craft services of the major powers and gain godlike power for himself. In a secret craft bunker in Virginia, he accessed the magic of one of the dead alternative Earths, or “hellworlds,” but the AWOL practitioners defeated him and cast his spirit into the hellworld. Farsight gives a probability of greater than five sigma of his destruction by the demonic entity of that world’s collective dead.")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("B. Major Dale Morton.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("Major Morton is the last craft-practicing scion of his family, and the most powerful living weatherman. He has a remarkable record of countercraft assassinations, but his mission to kill a Persian sorcerer (Operation Butterfly) has left him with a residual curse, and it remains unclear whether he could face a Muslim practitioner in combat. His efforts to find the traitor who set him up in Operation Butterfly led to the uncovering of the Left-Hand cabal within H-ring.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-After-tx-"
  }, [_vm._v("Major Morton’s father, grandfather, and biological mother are all deceased.")]), _vm._v(" "), _c('p', {
    staticClass: "List-Bullet-bl"
  }, [_vm._v("• His father discovered the possibility of the Left Hand tapping into a hellworld, but he drove himself insane during this investigation.")]), _vm._v(" "), _c('p', {
    staticClass: "List-Bullet-bl"
  }, [_vm._v("• His grandfather acted as Major Morton’s sole parent (living or dead) for most of his childhood.")]), _vm._v(" "), _c('p', {
    staticClass: "List-Bullet-bl"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_14",
      "title": "14"
    }
  }, [_vm._v("• Morton’s biological mother was code name Sphinx, aka Dare Smith, former Director of the Special Surveillance Service. This family connection to one of the greatest oracles of all time makes Morton and his close associates extremely difficult to track psychically.")])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("While the prejudice against the orthodox Morton line has been completely unjustified, the continued proximity of Dale Morton to Left-Hand influences and the Left Hand’s interest in him bears further observation.")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("C. Lieutenant Scherezade “Scherie” Rezvani.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("She is the most powerful exorcist in the world, which given the use of spiritual possession and necromancy by Left-Hand practitioners makes her an essential asset. She is also a skilled healer. Dale Morton is her spouse. Up until Lt. Rezvani’s emergence as a practitioner, her family was mundane, with any practice of craft falling below service jurisdiction. She was instrumental both in the inadvertent liberation of Roderick and in his eventual casting out from this world. She uses an inordinate amount of profanity to focus her emotions while working her exorcisms and dispellations.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Farsight and mundane reports indicate that Lt. Rezvani may be pregnant. If so, the sex (and therefore probable powers) of the child remain unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "Head-Level-1-h1"
  }, [_vm._v("II. THE ENDICOTT AND MARLOW FAMILIES")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("The Endicotts are descendants of John Endicott of Salem. Their spiritual gifts often include an exceptional power of command or suasion. With a few notorious exceptions, they have remained faithful to the beliefs and morals of their Puritan ancestors. The long-standing feud between the Endicotts and Mortons appears "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_15",
      "title": "15"
    }
  }, [_vm._v("to have ended with the friendship of Dale Morton and Michael Endicott.")])]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A. Major Michael G. Endicott.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("By rank and consensus, Major Endicott is the leader of the AWOL practitioners. He has recently acquired the so-called transnational power—that is, an ability to replenish and draw on craft power in any country, whether friendly or hostile. His power of command, formerly normal for someone of his Family, has also expanded greatly. Unchecked by self or others, he could become a new conqueror on the order of an Alexander or Caesar.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("While fleeing the UK through the Chunnel, Endicott was seriously wounded, and recovered only through an injection of the Left-Hand nanite serum. In a second attempt to kill him, this time by the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Oikumene")]), _vm._v(", Endicott lost an eye and some brain tissue, and he avoided death only through the synergy of the Left-Hand serum and his transnational power. During his fight with Roderick in the Virginia bunker, he lost half of his foot. But that which could not kill him has apparently only made him stronger.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Although Endicott’s loyalty to country and antipathy toward the Left-Hand way are as close to certainties as farsight determination allows, others (particularly the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Oikumene")]), _vm._v(") believe his exposure to the Left-Hand serum and his transnational power make him an imminent global threat.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Endicott’s father, General Oliver C. Endicott, died during the fight with the H-ring cabal. His spirit is in command of security at Arlington National Cemetery.")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("B. Abram Endicott.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("Deceased, spirit presumed departed. With his lover Madeline Morton, Abram headed the Left-Hand cabal within H-ring.")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_16",
      "title": "16"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("C. Royal Navy Commander Grace Marlow.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("Two of Commander Marlow’s earliest known practitioner ancestors were playwright and spy Christopher Marlowe and Tituba of Salem witch-hunt fame. Commander Marlow’s skills include stealth, theft, seduction, the detection and deployment of deception, and combat of all kinds. She has repeatedly saved Major Endicott’s life and was an essential part of Roderick’s defeat.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Major Endicott and Commander Marlow will be marrying soon in Japan. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("[Handwritten note in margin: “Tell them to stop asking what the hell she sees in Endicott. They may have the security clearance, but they clearly do not have a need to know.”]")]), _vm._v(" H-ring is sending Captain Katrina Hutchinson of their PRECOG section as the U.S. witness of their wedding. Captain Hutchinson is married to the current commander of countercraft operations, General Calvin Attucks, and is a family friend of both the Endicotts and Mortons through her cousin, the late Colonel Elizabeth Hutchinson. This makes her acceptable to all parties as a witness.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Below, I note some security concerns regarding the AWOL practitioners and their wedding.")]), _vm._v(" "), _c('p', {
    staticClass: "Head-Level-1-h1"
  }, [_vm._v("III. FOREIGN PRACTITIONERS OF CONCERN")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A. “Mr. Cushlee” Renfield.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("We have determined that this particular Renfield was responsible for several attempts on Major Endicott’s and Commander Marlow’s lives. He also violated Arlington National Cemetery in order to obtain the spirits of the unknown and forgotten dead for Roderick’s plans. We are near certain that this Renfield survived his involvement with Roderick; surviving such schemes is what his Family does best.")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_17",
      "title": "17"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("B. Vasilisa.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("Cryptonym of the only survivor of the Russian "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Spetsnaz Magi")]), _vm._v(" assault on Roderick at Chernobyl, where she was likely used as bait due to her general resemblance to Madeline. She aided Dale Morton’s escape from Moscow, and she’ll be attending the Endicott/Marlow wedding.")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("C. Miki Kaguya.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("An agent of Japan’s craft service, she was instrumental in obtaining a provisional asylum for Morton, Rezvani, Endicott, and Marlow. She has a previous professional and personal connection with Dale Morton. She also has some association with Japan’s craft black-ops group, aka the ninjas. (Yes, they’re real. You can tell that to anyone you’d like; the ninjas don’t seem to mind.)")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-2-h2"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("D. The")]), _vm._v(" "), _c('span', {
    staticClass: "R"
  }, [_vm._v("Oikumene")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("An international craft organization, they have opposed the Left Hand since the dawn of history. Their leader holds the office of Pythia. Fearing Major Endicott’s transnational power of command and his exposure to Left-Hand craft, the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Oikumene")]), _vm._v(" attempted his assassination, leaving him with the damage described above. On the other hand, they’ve shown some concern for Lt. Rezvani’s wellbeing.")]), _vm._v(" "), _c('p', {
    staticClass: "Head-Level-1-h1"
  }, [_vm._v("IV. STATUS OF AWOL PRACTITIONERS, THREATS, AND RESPONSE")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("You may be aware that, as a result of Roderick Morton’s infiltration of the major craft services, many of your fellow practitioners here and abroad are now subject to house arrest or other restrictions. Apparently, our four AWOL practitioners had advance knowledge of the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_18",
      "title": "18"
    }
  }, [_vm._v("repercussions of Roderick’s subversive activities and, after defeating him, fled in a government supersonic aircraft to their present residence in Tokyo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-After-tx-"
  }, [_vm._v("Farsight reveals intense worldwide focus on our AWOL practitioners and the upcoming Endicott-Marlow wedding. Motives for possible hostile action include but are not limited to:")]), _vm._v(" "), _c('p', {
    staticClass: "List-Bullet-bl"
  }, [_vm._v("• Denying the United States and Great Britain these assets")]), _vm._v(" "), _c('p', {
    staticClass: "List-Bullet-bl"
  }, [_vm._v("• Revenge for their anti-Left-Hand activities")]), _vm._v(" "), _c('p', {
    staticClass: "List-Bullet-bl"
  }, [_vm._v("• Concern about possible offspring from an international craft marriage (not everyone wants another Churchill)")]), _vm._v(" "), _c('p', {
    staticClass: "List-Bullet-bl"
  }, [_vm._v("• Obtaining certain intelligence information")]), _vm._v(" "), _c('p', {
    staticClass: "List-Bullet-bl"
  }, [_vm._v("• Continued concern from the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Oikumene")]), _vm._v(" regarding Endicott’s power and intentions")]), _vm._v(" "), _c('p', {
    staticClass: "List-Bullet-bl"
  }, [_vm._v("• An outstanding Renfield contract for the murder of one or more of the AWOL practitioners")]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("Together these four AWOL practitioners destroyed the most powerful mage in history. While they remain difficult to track in farsight, we can foresee that their survival is of central importance to U.S. and global security. They should also be regarded as extremely dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-After-tx-"
  }, [_vm._v("Therefore, all intelligence, farsight or otherwise, regarding the AWOL practitioners shall be sent directly to me and not shared with any other person or authority within or outside this service, and no action shall be taken regarding the AWOL practitioners without my express order.")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("By Order of the Director, Special Surveillance Service:")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("/s/")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("Eddy Edwards")]), _vm._v(" "), _c('div', {
    staticClass: "sp"
  }, [_c('p', {
    staticClass: "Head-Level-3-h3"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_19",
      "title": "19"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Addendum to Memorandum re: AWOL Practitioners")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-Space-After-tx1-"
  }, [_vm._v("I thought this went without saying, but again for absolute clarity, do not attempt to leave the country without my express order. The AWOL Practitioners could get away with it; you can’t. The recent surge in the number of identified practitioners does not mean that any particular absence will go unnoticed. If we can’t keep you, it’s EX-22: “Thou shalt not suffer a witch to live.”")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("/s/")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("EE")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext-First"
  }, [_vm._v("Classified by: J. Edgar Edwards")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("Reason: 1.5(c)(X1)")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-ext"
  }, [_vm._v("Declassify on: Not Applicable")])])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27645da5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 75
// module chunks = 0